import { IHasChildren } from '@/lib/interface';
import { Label } from '../ui';

type TProps = IHasChildren & {
  className?: string;
  required?: boolean;
}

const LabelRequired = ({ children, className, required = true }: TProps) => {

  let content = children;

  if (required) {
    content = (
      <>
        {content}
        <span className='text-red-500 ms-0.5'>
          *
        </span>
      </>
    );
  }

  return (
    <Label className={className}>
      {content}
    </Label>
  );

};

export default LabelRequired;
